import React from 'react';

const TRANSACTIONS = [
  { id: '15980', pkg: 'US Times Now', credit: '1 Press Release', duration: '90 Days', method: 'Paypal', amount: '15.00', token: 'PAYID-NHCS6WA609...', invoice: '0WF4816...', purchase: 'March 26, 2026', expiry: 'June 24, 2026' },
  { id: '15954', pkg: 'Business insider', credit: '1 Press Release', duration: '90 Days', method: 'Paypal', amount: '125.00', token: 'PAYID-NHBKV...', invoice: '8A81475...', purchase: 'March 24, 2026', expiry: 'June 22, 2026' },
  { id: '15936', pkg: 'Standard', credit: '10 Press Release', duration: '365 Days', method: 'Paypal', amount: '250.00', token: 'PAYID-NHAX4...', invoice: '0A85114...', purchase: 'March 23, 2026', expiry: 'March 23, 2027' },
];

export default function MyTransactions() {
  return (
    <div style={styles.container}>
      <div style={styles.headerRow}>
        <h2 style={styles.pageTitle}>My Transactions</h2>
        <input style={styles.searchInput} placeholder="Search Invoice..." />
      </div>

      <div className="card" style={{ padding: 0, overflowX: 'auto' }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Invoice Id</th>
              <th>Package Name</th>
              <th>Credit</th>
              <th>Duration</th>
              <th>Payment Method</th>
              <th>Amount Paid</th>
              <th>Token Id</th>
              <th>Invoice Id</th>
              <th>Purchase At</th>
              <th>Expired At</th>
            </tr>
          </thead>
          <tbody>
            {TRANSACTIONS.map((tx, i) => (
              <tr key={i}>
                <td>{tx.id}</td>
                <td>{tx.pkg}</td>
                <td><a href="#" style={styles.link}>{tx.credit}</a></td>
                <td>{tx.duration}</td>
                <td>{tx.method}</td>
                <td>{tx.amount}</td>
                <td>{tx.token}</td>
                <td>{tx.invoice}</td>
                <td>{tx.purchase}</td>
                <td>{tx.expiry}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { maxWidth: '1400px' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  pageTitle: { fontSize: '1.25rem', color: '#333' },
  searchInput: { padding: '0.6rem 1rem', border: '1px solid #e5e7eb', borderRadius: '4px', width: '300px', outline: 'none' },
  link: { color: '#1a62d5', textDecoration: 'none', fontWeight: 500 }
};
